import React from 'react';
import ColorBlockList from '../color-block-list';
import {BLUES, CYANS, VIOLETS, PINKS, REDS, MARIGOLDS, GREENS} from './constants';

const SECONDARY_BLUES = BLUES.filter((blue) => blue.type === 'secondary');
const SECONDARY_CYANS = CYANS.filter((cyan) => cyan.type === 'secondary');
const SECONDARY_VIOLETS = VIOLETS.filter((violet) => violet.type === 'secondary');
const SECONDARY_PINKS = PINKS.filter((pink) => pink.type === 'secondary');
const SECONDARY_REDS = REDS.filter((red) => red.type === 'secondary');
const SECONDARY_MARIGOLDS = MARIGOLDS.filter((marigold) => marigold.type === 'secondary');
const SECONDARY_GREENS = GREENS.filter((green) => green.type === 'secondary');

class SecondaryColors extends React.Component {
  render() {
    return (
      <div>
        <ColorBlockList groupName="Blue" colors={SECONDARY_BLUES} />
        <ColorBlockList groupName="Cyan" colors={SECONDARY_CYANS} />
        <ColorBlockList groupName="Violet" colors={SECONDARY_VIOLETS} />
        <ColorBlockList groupName="Pink" colors={SECONDARY_PINKS} />
        <ColorBlockList groupName="Red" colors={SECONDARY_REDS} />
        <ColorBlockList groupName="Marigold" colors={SECONDARY_MARIGOLDS} />
        <ColorBlockList groupName="Green" colors={SECONDARY_GREENS} />
      </div>
    );
  }
}

export default SecondaryColors;
